<div class="d-flex justify-content-center gap-2 flex-column flex-sm-row align-items-center">
  <span id="paginierung-termine-treffervonbis" class="align-self-center"
    >{{ ersterTreffer | number }}-{{ letzterTreffer | number }} von {{ totalItems }}</span
  >
  <now-wbsuche-lib-pagination-dpl
    id="paginierung-termine"
    [anzahlTreffer]="totalItems"
    [aktuelleSeite]="currentPage"
    [anzahlSeiten]="anzahlSeiten"
    [position]="'unten'"
    [idSuffix]="'termin'"
    (firstClicked)="pageFirstClicked()"
    (prevClicked)="pagePrevClicked()"
    (nextClicked)="pageNextClicked()"
    (lastClicked)="pageLastClicked()"
    (threePagesPreviousClicked)="threePagesBackwards()"
    (threePagesNextClicked)="threePagesForwards()"
  ></now-wbsuche-lib-pagination-dpl>
</div>
